import tw from "tailwind-styled-components";

export const GreenLinkBtn = tw.div`
bg-green-500
flex
justify-between
 hover:bg-emerald-500 
 text-white
  font-bold 
  py-1 
  px-3 
  rounded 

  mr-2

`;

export const VioletLinkBtn = tw.div`
bg-indigo-500
flex
justify-between
 hover:bg-indigo-500 
 text-white
  font-bold 
  py-1 
  px-3 
  rounded 

  mr-2

`;

export const BtnView = tw.button`
bg-blue-500 
hover:bg-blue-700 
text-white 
font-bold
px-1
rounded 


`;
